import {dataHooks} from '@wix/data-hooks'
import {Status} from '@wix/ambassador-table-reservations-v1-time-slot/types'

import {ShowSlotsBehavior} from '../Settings/Tabs/Display/settingsParams'

export const reservationsDataHooks = dataHooks<{
  root: {}
}>('reservations')

export enum ReservationsPageType {
  DEFAULT,
  EXTENDED,
  EMPTY,
}

export const SlotsSettingToStatus: Record<ShowSlotsBehavior, Status[]> = {
  [ShowSlotsBehavior.All]: [Status.AVAILABLE, Status.NON_WORKING_HOURS, Status.UNAVAILABLE],
  [ShowSlotsBehavior.Available]: [Status.AVAILABLE],
}

export const SlotsSettingToRequestedSlotsQuantity: Record<ShowSlotsBehavior, number> = {
  [ShowSlotsBehavior.All]: 7,
  [ShowSlotsBehavior.Available]: 50,
}
